module.exports = __webpack_public_path__ + "static/media/5.887c5fe9.jpg";